import { BaseApiService } from '@shared/services/BaseApiService';
import { API_URL } from '@shared/helpers/env';
import axios from 'axios';

class AuthServiceClass extends BaseApiService {
  constructor(opts) {
    super(opts);
  }

  login(params = {}) {
    return this.http.post('/login', params);
  }

  token() {
    return axios.get(`${API_URL}/api/v3/frontend/csrf`);
  }
}

export const AuthService = new AuthServiceClass({
  api_version: 2,
  resource: 'auth'
});
